import React from "react";
import BlueCardReviewCertificationDetail from "./BlueCardCertificationDetail";
import BlueCardReviewCertificationList from "./BlueCardCertificationList";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import SpinnerLoader from "../../Common/SpinnerLoader";

class BlueCardCertification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: "list",

      selectedAssetId: null,
      selectedYear: null,
      spinnerLoading: false,
    };

    this.onViewReport = this.onViewReport.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onCertify = this.onCertify.bind(this);
  }

  componentDidMount() {
    this.props.getBlueCardCertificationLists(`/pendingReviewBlueCards`);
  }

  componentDidUpdate(prevProps) {
    const { actionType, BlueCardActionType, BlueCardCertificationListActionType, BlueCardCertificationDetailActionType } = this.props;
    if (
      BlueCardCertificationListActionType === "BLUECARDCERTIFICATIONLISTS_READ_REQUEST" &&
      BlueCardCertificationListActionType !== prevProps.BlueCardCertificationListActionType
    ) {
      this.setState({ spinnerLoading: true });
    }

    if (
      BlueCardCertificationListActionType === "BLUECARDCERTIFICATIONLISTS_READ_SUCCESS" &&
      BlueCardCertificationListActionType !== prevProps.BlueCardCertificationListActionType
    ) {
      this.setState({ spinnerLoading: false });
    }

    if (BlueCardActionType === "BLUECARDS_READ_REQUEST" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: true });
    }
    if (BlueCardActionType === "BLUECARDS_READ_SUCCESS" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: false });

      this.props.getBlueCardCertificationDetails(
        `/pendingReviewBlueCardDetails?year=${this.state.selectedYear}&assetId=${this.state.selectedAssetId}`,
      );
    }

    if (BlueCardActionType === "BLUECARDS_READ_FAILURE" && BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: false });
    }

    if (
      BlueCardCertificationDetailActionType === "BLUECARDCERTIFICATIONDETAILS_READ_REQUEST" &&
      BlueCardCertificationDetailActionType !== prevProps.BlueCardCertificationDetailActionType
    ) {
      this.setState({ spinnerLoading: true });
    }

    if (
      BlueCardCertificationDetailActionType === "BLUECARDCERTIFICATIONDETAILS_READ_SUCCESS" &&
      BlueCardCertificationDetailActionType !== prevProps.BlueCardCertificationDetailActionType
    ) {
      this.setState({ spinnerLoading: false });
    }

    if (
      BlueCardCertificationDetailActionType === "BLUECARDCERTIFICATIONDETAILS_READ_FAILURE" &&
      BlueCardCertificationDetailActionType !== prevProps.BlueCardCertificationDetailActionType
    ) {
      this.setState({ spinnerLoading: false });
    }
  }

  onViewReport(assetId, year) {
    this.setState({
      viewMode: "detail",
      selectedAssetId: assetId,
      selectedYear: year,
    });

    this.props.getBlueCards(`/getBlueCard?year=${year}&assetId=${assetId}`);
  }

  onBack() {
    // go back to list
    this.setState({
      viewMode: "list",
      selectedAssetId: null,
      selectedYear: null,
    });
  }

  onCertify() {
    this.setState({
      viewMode: "list",
      selectedAssetId: null,
      selectedYear: null,
    });

    this.props.getBlueCardCertificationLists(`/pendingReviewBlueCards`);
  }
  render() {
    const { viewMode } = this.state;

    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />
        {viewMode === "detail" ? (
          <BlueCardReviewCertificationDetail
            onBack={this.onBack}
            onCertify={this.onCertify}
            selectedYear={this.state.selectedYear}
            selectedReviewBlueCard={this.props.BlueCards}
            selectedReviewBlueCardDetails={this.props.BlueCardCertificationDetails}
          />
        ) : (
          <BlueCardReviewCertificationList onViewReport={this.onViewReport} />
        )}
      </div>
    );
  }
}

const getBlueCardCertificationLists = curdActions.getBlueCardCertificationLists;
const getBlueCardCertificationDetails = curdActions.getBlueCardCertificationDetails;
const getBlueCards = curdActions.getBlueCards;
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    getBlueCardCertificationLists,
    getBlueCardCertificationDetails,
    getBlueCards,
  },
};

let variables = {
  BlueCardCertificationListReducer: { BlueCardCertificationLists: [] },
  BlueCardCertificationDetailReducer: { BlueCardCertificationDetails: [] },
  BlueCardReducer: { BlueCards: [] },
};

const BlueCardCertificationContainer = CRUDFunction(
  BlueCardCertification,
  "BlueCardCertification",
  actionOptions,
  variables,
  ["BlueCardCertificationListReducer", "BlueCardCertificationDetailReducer", "BlueCardReducer"],
  "blueCard",
);

export default BlueCardCertificationContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/BlueCardsCertification/BlueCardCertification.jsx